<div class="row page-div">
    <div class="col-md-6 mx-auto">
        <div class="col-md-12 text-right mx-auto">
            <div class="text-center page-header">{{ 'privacy-policy.header' | translate }}</div>
            <div class="justify-content-center align-items-center content-div text-center">
                <div class="instruction-border">
                    <ul class="record-list text-right">
                        <li>
                            <span class="li-header">1. מי אנחנו:</span>
                            <div>
                                חברתנו, סיימן טכנולוגיות בע"מ, ח.פ. ,513421461 מרח׳ גוש עציון ,11 גבעת שמואל;
                                טל׳ 03-6199199; דוא״ל: <span dir="ltr"
                                    style="text-align:left; display:inline-block;">;sales@enativ.com</span> דומיין:
                                <span dir="ltr" style="text-align:left; display:inline-block;">enativ.com</span>, אשר
                                הקימה ומפעילה את הסנן
                                האינטרנטי ״נתיב״, רואה חשיבות עליונה בשמירה על פרטיות המשתמשים בשירותינו.
                            </div><br />
                            <div>
                                מסמך זה נועד לפרט את מדיניות הפרטיות הנהוגה בשירות הסינון של נתיב, ובפרט את אופן איסוף
                                המידע, השימוש בו, וכן את אופן שמירתו
                            </div>
                            <br />
                        </li>
                        <li>
                            <span class="li-header">2. המידע הנאסף במסגרת מתן שירותי הסינון – אל מול פירוט הצורך
                                במידע:</span>
                            <div>
                                א. שם, כתובת, טל׳, כתובת דוא״ל – לצורך קיום הקשר עם הלקוח.
                            </div>
                            <div>ב. נתונים כספיים – מועברים במישרין לרו״ח החברה וכן לחברת הסליקה לצורך חיוב הלקוח.</div>
                            <div>ג. תמונות מאתרים מורשים בלבד – נשמרות עד חודש ימים (בצירוף כתובת URL של התמונה)
                                במטרה לאפשר ללקוח קיום דיון עתידי/מאוחר עמנו בנוגע להחלטתנו לסנן את הצפיה באותה
                                תמונה. לא נשמר כל הקשר שביכולתו לגרום לזיהוי בין הלקוח לבין התמונה שנשמרה.</div>
                            <div>ד. מידע טכני וזהות ספק האינטרנט – לצורך מתן השירות בפועל.</div>
                            <div>ה. נתוני גלישה בסיסיים הכוללים כתובות IP וכתובות URL נשמרים לצורכי תפקוד תקין של
                                המערכת למשך 24 שעות בלבד ואינם משויכים למזהים אישיים של המשתמשים.</div>
                            <br />
                        </li>
                        <li>
                            <span class="li-header">3. אופן איסוף המידע ושמירתו המאובטחת:
                            </span>
                            <div>
                                המידע בעניין פרטים אדמיניסטרטיביים (שם, טל', כתובת, כתובת מייל) נאסף המסגרת שיחת
                                הרישום או בפניה דרך האתר, והמידע הטכני נאסף במהלך השימוש בתוכנה, באופן בו כל תעבורת
                                הרשת מהמחשב בו מותקנת תוכנת הסינון של נתיב עוברת דרך רכיב תוכנה מסוג Proxy המותקן
                                מקומית במחשב המשתמש. רכיב זה מנתב את הגלישה בהתאם למדיניות הסינון שנקבעה מראש
                                (אתרים שהוגדרו כ"מוחרגים" אינם עוברים דרך רכיב הסינון, ותעבורת הרשת אליהם מתבצעת
                                ישירות).
                            </div>
                            <br />
                            <div>הגדרות הסינון – הכוללות רשימות אתרים מותרים ואתרים חסומים – נשמרות בשרת ייעודי של
                                נתיב. הנתונים נשמרים בפורמט בינארי שאינו קריא באופן ישיר, ונגישים אך ורק באמצעות שירות
                                <span dir="ltr" style="text-align:left; display:inline-block;">WEB SERVICE</span>
                                ייעודי ומוגן.
                            </div>
                            <br />
                            <div>
                                כל המידע הנשמר על-ידי נתיב מאוחסן במערכות מאובטחות, תוך הקפדה על תקני אבטחת מידע
                                מחמירים. הגישה למידע מוגבלת אך ורק לצוותים מורשים, ולמטרות תפעול ותחזוקה של מערכת
                                הסינון בלבד
                            </div>
                            <br />
                            <div>
                                על מנת למנוע גישה לא מורשית, שימוש לא חוקי או אובדן של המידע, אנו משתמשים
                                ב FIREWALL, וכן באימות כפול בגישה לממשק הנתונים.
                            </div>
                            <br />
                        </li>
                        <li>
                            <span class="li-header">4. מטרת השימוש במידע:</span>
                            <div>
                                המידע נאסף לצורך התפעול השוטף של המערכת, גביית תשלום חודשי, משלוח ראוטר לבית הלקוח
                                (רכיב לצורך ביצוע גלישה אינטרנטית, לפי בקשת הלקוח), שליחת עדכונים ללקוח, וכן שיפור
                                מתמיד של סנן נתיב ואתר האינטרנט.
                            </div>
                            <br />
                            <div>
                                ללקוח שמורה הזכות המלאה להתעדכן בדבר המידע שנאסף, לתקנו ו/או לדרוש את מחיקתו ואת
                                הפסקת השימוש בו, אך הדבר יביא להפסקת קבלת השירות, שכן הענקתו ללקוח תלויה באיסוף
                                המידע המפורט לעיל.
                            </div>
                            <br />
                            <div>
                                מובהר כי איננו מבצעים כל ניתוח ו/או סיווג של המידע.
                            </div>
                            <br />
                        </li>
                        <li>
                            <span class="li-header">5. הגופים החיצוניים החשופים למידע שנאסף:</span>
                            <div>
                                המידע הכספי מועבר לרו״ח החברה וכן לחברת הסליקה בלבד, ולצורך חיוב הלקוח בלבד; כתובת
                                הלקוח מועבר לחברת השליחויות בלבד, והדבר נעשה אך ורק אם הלקוח ביקש לקבל ראוטר לביתו
                                במסגרת תכנית הגלישה שעשה באמצעות נתיב.
                            </div>
                            <br />
                        </li>
                        <li>
                            <span class="li-header">6. שינויים במדיניות הפרטיות</span>
                            <div>
                                נתיב שומרת לעצמה את הזכות לעדכן את מדיניות הפרטיות מעת לעת, בהתאם לשינויים
                                טכנולוגיים, רגולטוריים או תפעוליים. בכל מקרה של שינוי מהותי, תינתן הודעה מתאימה
                                למשתמשים.
                            </div>
                            <br />
                        </li>
                    </ul>
                    <ul class="text-center comment-div">
                        <li>
                            נא סמן V לצורך מתן הסכמה למדיניות הפרטיות של חברתנו לאחר קריאתה במלואה:
                            <input type="checkbox" class="big-checkbox" (change)="onCheckboxChange($event)" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="white-nav">
    <app-bottom-nav></app-bottom-nav>
</div>